import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import PropTypes from 'prop-types';

// Redux

function PrivateWrapper({
  component: Component, token, user_role, ...rest
}) {
  if (token === null || user_role === null || typeof user_role !== 'number' || user_role > 4) {
    return <Redirect to="/" />;
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}

PrivateWrapper.propTypes = {
  component: PropTypes.oneOfType([Route.propTypes.component, PropTypes.object]).isRequired,
  token: PropTypes.string,
  user_role: PropTypes.number.isRequired,
};

PrivateWrapper.defaultProps = {
  token: null,
};

const mapStateToProps = (state) => ({
  token: state.signin.token,
  user_role: state.roles.user_role,
});

export default connect(mapStateToProps)(PrivateWrapper);
